import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
export default function Pagination(props) {
  let { length, activePage, onChange } = props;
  const [value, setValue] = useState(1);
  const [listedPages, setListedPages] = useState([]);

  useEffect(() => {
    renderPages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, length]);

  useEffect(() => {
    // activePage propu gelirse value stateini değiştir.
    setValue(activePage);
  }, [activePage]);

  const renderPages = () => {
    let pageLength = length;
    let size = 5; // default
    let pagingLenght = 10; // default
    let pages = [];

    if (window.innerWidth <= 480) {
      size = 3;
      pagingLenght = 5;
    }

    if (pageLength <= pagingLenght) {
      // sayfa sayısı pagingLenght ve pagingLenght'den küçükse hiç bir sayfayı gizlemeden hepsini yazdır
      for (let index = 1; index < pageLength + 1; index++) {
        pages.push({ no: index, content: index });
      }
      setListedPages(pages);
    }
    if (pageLength > pagingLenght) {
      // sayfa sayısı pagingLenght'den büyükse size'ten sonraki sayfaların gizlenmesi
      // eğer aktif sayfa size ve size'ten küçükse size'e kadar sayfaları çizdir
      if (value <= size) {
        for (let index = 1; index < size + 1; index++) {
          pages.push({ no: index, content: index });
        }
        pages.push({ no: length - size, content: "..." });
        pages.push({ no: pageLength, content: pageLength });
      }
      if (value > size) {
        // aktif sayfa size'ten büyükse ve aktif sayfa son size sayfa içindeyse '...' ya tıklayınca sayfa size'e git ekle.
        // sadece ilk sayfa, ... , ve son size sayfa renderlanır.
        if (length - size <= value) {
          pages.push({ no: 1, content: 1 });
          pages.push({ no: size, content: "..." });
          for (let index = length - size; index < length + 1; index++) {
            pages.push({ no: index, content: index });
          }
        } else {
          // aktif sayfa size'ten büyükse ve aktif sayfa son size sayfa içinde değilse '...' ya tıklayınca sondan size. sayfaya git ekle.
          // sadece aktif son size sayfa ,..., son sayfa renderlanır
          for (let index = value - 4; index < value + 1; index++) {
            pages.push({ no: index, content: index });
          }
          pages.push({ no: length - size, content: "..." });
          pages.push({ no: length, content: length });
        }
      }
    }
    setListedPages(pages);
  };
  const isSelected = (no) => {
    if (value === no) return true;
    return false;
  };
  const changePage = (no) => {
    onChange(no);
    setValue(no);
  };
  const prevPage = () => {
    changePage(value - 1);
  };
  const nextPage = () => {
    changePage(value + 1);
  };

  return (
    <ul className="km__c--pagination">
      <li className="km__c--pagination-navigation-icon">
        <button
          onClick={prevPage}
          disabled={value === 1}
          data-button-type="prev"
        >
          <Icon name="chevron-left" size="18" />
        </button>
      </li>
      {listedPages.map((page) => {
        return (
          <li key={page.no}>
            <button
              data-page-no={page.no}
              className={
                isSelected(page.no) ? "km__c--pagination-is-active" : ""
              }
              onClick={() => changePage(page.no)}
            >
              {page.content}
            </button>
          </li>
        );
      })}

      <li className="km__c--pagination-navigation-icon">
        <button
          onClick={nextPage}
          disabled={value === length}
          data-button-type="next"
        >
          <Icon name="chevron-right" size="18" />
        </button>
      </li>
    </ul>
  );
}
Pagination.propTypes = {
  length: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  activePage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
};
